// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import styled from 'styled-components';

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    display: none;
  }
`;

const StyledTitle = styled.h4`
  color: #da0062;
  margin: 0 30px 0 15px;
`;

const StyledFilters = styled.div`
  button {
    height: 37px;
    padding: 0 10px;
    color: #ffffff;
    background: #da0062;
    border: 1px solid #bd105b;
    border-radius: 2px;
    font-weight: 600;
    font-size: 16px;
    margin-right: 20px;
    outline: none;
    &:hover,
    &:active,
    &:active:hover {
      border: 1px solid #bd105b;
      color: #ffffff;
      background: #da0062;
    }
  }
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const QuickOrdersFilters = ({ onQuickFilterClick, filters }) => {
  return (
    <StyledWrapper>
      <StyledTitle>Quick Filters:</StyledTitle>
      <StyledFilters>
        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line react/prop-types */}
        {filters.map(f => (
          <button
            key={f.filter + f.sort}
            type='button'
            onClick={() => onQuickFilterClick(f.filter, f.sort)}
          >
            {f.text}
          </button>
        ))}
      </StyledFilters>
    </StyledWrapper>
  );
};

export default QuickOrdersFilters;
